import { Component, OnInit } from '@angular/core';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { PdfZaDostavniceService } from 'src/app/pdf-ovi/pdfZaDostavnice.service';
import { PdfZaOtpremnicePekarTomoService } from 'src/app/pdf-ovi/pdfZaOtpremnicePekarTomo.service';
import { moduli } from '../../config';
import { custom } from 'devextreme/ui/dialog';
import { DostavnicaService } from './dostavnica.service';
import DataSource from 'devextreme/data/data_source';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-dostavnica',
  templateUrl: './dostavnica.component.html',
  styleUrls: ['./dostavnica.component.scss'],
})
export class DostavnicaComponent implements OnInit {
  dostavnice: any = [];
  stavke: any = [];
  naslov: string;
  today: Date = new Date();
  poslovnicePekar: any = [];
  poslovniceTomo: any = [];
  prijevoznici: any = [];
  partneri: any = [];
  poslovnicePartnera: any = [];
  poslovnicePartneraFilter: any = [];
  pocetni_provjera: any = [];
  poslovnicaPartnera_id: any;
  do_id_narudzba: any = null;
  partneriCrossdock: any = [];
  neobradeneNarudzbe: any = [];
  datumOd = moment().subtract(1, 'days');
  datumDo = moment();
  datumOdFormatiran: string = this.datumOd.format('YYYY-MM-DD');
  datumDoFormatiran: string = this.datumDo.format('YYYY-MM-DD');
  idDostavnice: number;
  poruka: string;
  disableGumb: boolean = false;
  disable_ssccBroj: boolean = false;
  obavezan_sscc_pocetno: boolean = false;
  obavezan_sscc: boolean = false;

  prikazi: any = [
    { idprikaz: 1, pr_naziv: 'DA' },
    { idprikaz: 0, pr_naziv: 'NE' },
  ];

  // ZA DODAVANJE STAVKI
  idProizvoda: any;
  radniNalog_id: any;
  lotBroj: any;
  brojKutija: any;
  sscc: any;
  brojIstihPaleta: any;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  popupAddPalleteVisible: boolean = false;

  povezani_dokumenti: any = [];
  povezaniDokumentiPopup = false;
  window: any;

  sviProizvodi: any;
  odabraniProizvod: any;
  sviLotovi: any[] = [];
  sviLotoviDataSource: any;
  sifraPoslovnice: any;
  idkorisnik: any;
  access_token: any;
  idfirma: any;
  fazaId: any;

  sifraArtikla: any;

  datumDokumenta: any;
  godinaDokumenta: any;
  registracijaVozila: any;
  brojKamiona: any;
  sifraPartnera: any;
  disabledOdobri: any = false;
  iddostavnica: any;

  loadingVisible = false;
  dozvoli_export: boolean = false;

  constructor(private dostavniceService: PdfZaDostavniceService, private service: DostavnicaService, private otpremnicePekarTomoService: PdfZaOtpremnicePekarTomoService) {

    this.onShowing = this.onShowing.bind(this);

    this.idkorisnik = localStorage.getItem('idsecuser');
    this.access_token = sessionStorage.getItem('token');
    this.idfirma = localStorage.getItem('firma');

    //console.log('sessionStorage iddostavnica: ', sessionStorage.getItem('iddostavnica'))
    if (sessionStorage.getItem('iddostavnica')) {
      this.iddostavnica = sessionStorage.getItem('iddostavnica');
      this.dohvatiDostavnicu();
    } else {
      //this.dohvatiDostavnice(this.datumOdFormatiran, this.datumDoFormatiran);
    }

    this.dohvatiPrijevoznike();
    this.dohvatiPoslovnicePekar();
    this.dohvatiPoslovniceTomo();
    this.dohvatiPartnere_i_poslovnice();
    this.partnerPopis();
    this.partnerOdabran = this.partnerOdabran.bind(this);
    this.poslovnicaPartneraOdabrana = this.poslovnicaPartneraOdabrana.bind(this);
    this.changeBrojNarudzbe = this.changeBrojNarudzbe.bind(this);

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().dostavnice;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    this.dohvatiSveProizvode();
  }

  //kad se ide iz pregleda "Otpremnice" preko linka (Broj dostavnice) na pregled "Dostavnice" poziva se isti api kao za popis samo sto vraca tu jednu odabranu a ne popis svih dostavnica
  dohvatiDostavnicu() {
    this.dostavnice = [];
    this.dozvoli_export = false;
    let podaciZaSlanje = {
      idfirma: this.idfirma,
      idkorisnik: this.idkorisnik,
      iddostavnica: this.iddostavnica
    };
    this.service.dohvatiDostavnice(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success == true) {
        this.dostavnice = res.data;
      }
      if (res.data.length > 0) {
        this.dozvoli_export = true;
      } else {
        this.dozvoli_export = false;
      }
    });
  }

  dohvatiDostavnice(datumod, datumdo): void {
    this.poruka = 'Učitavanje...';
    this.disableGumb = true;
    this.dostavnice = [];
    this.dozvoli_export = false;
    const data = {
      datumod: datumod,
      datumdo: datumdo,
    };
    this.service.dohvatiDostavnice(data).subscribe((res) => {
      //console.log(res);
      this.disableGumb = false;
      if (res.success === true) {
        this.dostavnice = res.data;
      }

      if (this.dostavnice.length > 0) {
        this.poruka = 'Učitavanje...';
        this.dozvoli_export = true;
      } else {
        this.poruka = 'Nema podataka za prikaz!';
        this.dozvoli_export = false;
      }
    });
  }

  dohvatiPrijevoznike() {
    this.prijevoznici = [];
    this.service.dohvatiPrijevoznike({}).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.prijevoznici = res.data;
      }
    });
  }

  dohvatiPoslovnicePekar() {
    let podaciZaSlanje = {
      idfirma: this.idfirma,
      idkorisnik: this.idkorisnik,
      access_token: this.access_token,
    };
    this.poslovnicePekar = [];
    this.service.poslovnicaPopis(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.poslovnicePekar = res.data;
      }
    });
  }

  dohvatiPoslovniceTomo() {
    this.poslovniceTomo = [];
    this.service.dohvatiPoslovniceTomo({}).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.poslovniceTomo = res.data;
      }
    });
  }

  dohvatiPartnere_i_poslovnice() {
    this.partneri = [];
    this.poslovnicePartnera = [];
    this.service.dohvatiPartnere({ idkorisnik: this.idkorisnik, idfirma: this.idfirma }).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.partneri = res.data.partneri;
        this.poslovnicePartnera = res.data.poslovnicepartnera;
      }
    });
  }

  partnerPopis() {
    this.partneriCrossdock = [];
    this.service.partnerPopis({ idkorisnik: this.idkorisnik, idfirma: this.idfirma }).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.partneriCrossdock = new DataSource({
          store: res.data
        });
      }
    });
  }

  onShowing(e: any) {
    e.component.option("title", this.naslov);
  }

  onInitNewRow(e: any) {
    //console.log(e);
    this.naslov = 'Dodaj dostavnicu';
    e.data.pz_datum = moment(this.today).format('YYYY-MM-DD');
  }

  onEditingStart(e) {
    //console.log(e.data);
    this.naslov = 'Uredi dostavnicu';
    this.pocetni_provjera = e.data;
    this.poslovnicaPartnera_id = e.data.poslovnicapartnera_pp_id_kupac;
    this.do_id_narudzba = e.data.dokument_do_id_narudzba;

    let ppFilter = [];
    ppFilter = this.poslovnicePartnera.filter(function (a) { return a.partner_pa_id == e.data.partner_pa_id_kupac; })
    //console.log(ppFilter);
    this.poslovnicePartneraFilter = ppFilter;
    //console.log(this.poslovnicePartneraFilter);

    //console.log('poslovnicapartnera_pp_id_kupac: ', e.data.poslovnicapartnera_pp_id_kupac); 
    if (e.data.poslovnicapartnera_pp_id_kupac) {
      this.dohvatiNeobradeneNarudzbe();
    }
  }

  partnerOdabran(e) {
    //console.log(e);
    //console.log(e.itemData);
    this.poslovnicaPartnera_id = null;

    if (this.pocetni_provjera.partner_pa_id_kupac == e.itemData.pa_id) {
      this.poslovnicaPartnera_id = this.pocetni_provjera.poslovnicapartnera_pp_id_kupac;
    }

    let ppFilter = [];
    ppFilter = this.poslovnicePartnera.filter(function (a) { return a.partner_pa_id == e.itemData.pa_id; })
    //console.log(ppFilter);
    this.poslovnicePartneraFilter = ppFilter;
    //console.log(this.poslovnicePartneraFilter);
  }

  poslovnicaPartneraOdabrana(e) {
    //console.log(e);
    //console.log(e.itemData);
    this.poslovnicaPartnera_id = e.itemData.pp_id;
    this.pocetni_provjera.poslovnicapartnera_pp_id_kupac = this.poslovnicaPartnera_id;

    this.dohvatiNeobradeneNarudzbe();
  }

  changeBrojNarudzbe(e) {
    //console.log(e);
    this.do_id_narudzba = e.itemData.do_id;
  }

  dohvatiNeobradeneNarudzbe() {
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      poslovnicapartnera_pp_id: this.poslovnicaPartnera_id
    }
    //console.log(podaciZaSlanje);
    this.neobradeneNarudzbe = [];
    this.service.neobradeneNarudzbe_otpremarobe(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.neobradeneNarudzbe = res.data;
      }
    });
  }

  dodajDostavnicu(e) {
    //console.log(e);
    this.loadingVisible = true;
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      datum: moment(e.data.pz_datum).format('YYYY-MM-DD'),
      poslovnica_po_id: e.data.poslovnica_po_id,
      poslovnicapartnera_pp_id: e.data.poslovnicapartnera_pp_id,
      partner_pa_id_kupac: e.data.partner_pa_id_kupac,
      poslovnicapartnera_pp_id_kupac: this.poslovnicaPartnera_id,
      dokument_do_id_narudzba: this.do_id_narudzba,
      idprijevoznik: e.data.partner_pa_id_vezni,
      registracija: e.data.pz_registracijavozila,
      rbkamiona: e.data.pz_rednibrojslepera,
      crossdock_id: e.data.crossdock_id
    };
    //console.log(podaciZaSlanje);
    this.service.kreirajDostavnicu(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      this.loadingVisible = false;
      if (res.success === true) {
        this.dohvatiDostavnice(this.datumOdFormatiran, this.datumDoFormatiran);
        notify('Uspješno dodana dostavnica.', 'success', 3000);
      } else {
        notify(res.message, 'error', 3000);
      }
    });
  }

  urediZaglavlje(e) {
    //console.log(e);
    //console.log(e.data.poslovnicapartnera_pp_id_kupac);
    if (e.data.pz_status != 'Z') {
      this.loadingVisible = true;
      const data = {
        pz_id: e.data.pz_id,
        loginizmjena: Number(localStorage.getItem('idsecuser')),
        datum: moment(e.data.pz_datum).format('YYYY-MM-DD'),
        rbkamiona: e.data.pz_rednibrojslepera,
        registracija: e.data.pz_registracijavozila,
        partner_pa_id_kupac: e.data.partner_pa_id_kupac,
        poslovnicapartnera_pp_id_kupac: this.poslovnicaPartnera_id,
        dokument_do_id_narudzba: this.do_id_narudzba,
        prijevoznik: e.data.partner_pa_id_vezni,
        idposlovnicapartnera: e.data.poslovnicapartnera_pp_id,
        poslovnica_po_id: e.data.poslovnica_po_id,
        crossdock_id: e.data.crossdock_id
      };
      //console.log(data);
      this.service.urediZaglavljeDostavnice(data).subscribe((res) => {
        //console.log(res);
        this.loadingVisible = false;
        if (res.success === true) {
          this.dohvatiDostavnice(this.datumOdFormatiran, this.datumDoFormatiran);
          notify('Uspješno uređena dostavnica.', 'success', 3000);
        }
      });
    } else {
      notify('Nije moguće mjenjati završeni dokument.', 'warning', 3000);
    }
  }

  urediStavku(e) {
    //console.log(e);
    if (e.data.sscc_broj) {
      if (e.data.sscc_broj.length == 20) {
        let podaciZaSlanje = {
          sscc: e.data.sscc_broj
        }
        this.service.provjeri_sscc(podaciZaSlanje).subscribe(res => {
          //console.log(res);
          if (res.success == true) {
            //console.log('____dobar_sscc_____');
            this.uredi(e);
          } else {
            notify('Uneseni SSCC kod je već upisan!!!', 'error', 3000);
            this.dohvatiStavke();
          }
        });
      } else {
        notify('Neodgovarajuća dužina SSCC koda!', 'error', 3000);
        this.dohvatiStavke();
      }
    } else {
      e.data.sscc_broj = null;
      this.uredi(e);
    }
  }

  uredi(e) {
    //console.log(e);
    const data = {
      idlotpromet: e.data.idlotpromet,
      sscc: e.data.sscc_broj,
    };
    //console.log(data);
    this.service.urediStavkuDostavnice(data).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        notify('Uspješna promjena SSCC broja.', 'success', 3000);
      } else {
        notify(res.message, 'error', 3000);
      }
      this.dohvatiStavke();
    });
  }

  obrisiStavku(e) {
    //console.log(e);
    const data = {
      idlotpromet: e.data.idlotpromet,
    };
    //console.log(data);
    this.service.obrisiStavkuDostavnice(data).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        let dostavnicaKojojSeSmanjujeBrojPaleta = this.dostavnice.find(d => d.pz_id === e.data.prometzag_pz_id);
        //console.log(dostavnicaKojojSeSmanjujeBrojPaleta.brojpaleta);
        dostavnicaKojojSeSmanjujeBrojPaleta.brojpaleta = dostavnicaKojojSeSmanjujeBrojPaleta.brojpaleta - 1;
        //console.log(dostavnicaKojojSeSmanjujeBrojPaleta.brojpaleta);
        notify('Uspješna obrisana stavka.', 'success', 3000);
      }
      this.dohvatiStavke();
    });
  }

  obrisiDostavnicu(e) {
    //console.log(e.data);
    let podaciZaSlanje = {
      idfirma: this.idfirma,
      idkorisnik: this.idkorisnik,
      pz_id: e.data.pz_id,
    };
    //console.log(podaciZaSlanje);
    this.service.dostavnicaObrisi(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        notify('Dostavnica uspješno obrisana.', 'success', 3000);
      }
      this.dohvatiDostavnice(this.datumOdFormatiran, this.datumDoFormatiran);
    });
  }

  odobriDostavnicu(e) {
    //console.log(e);
    this.disabledOdobri = true;
    let myDialog = custom({
      title: "Odobravanje",
      messageHtml: "Jeste li sigurni da želite završiti dokument?",
      buttons: [{
        text: "DA",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      }, {
        text: "NE",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      }]
    });
    myDialog.show().then((dialogResult: any) => {
      //console.log(dialogResult.buttonText);
      if (dialogResult.buttonText === 'DA') {
        const data = {
          idpartner: e.data.partner_pa_id,
          idfirma: e.data.firma_fi_id,
          login: Number(localStorage.getItem('idsecuser')),
          pz_id: e.data.pz_id,
        };
        //console.log(data);
        this.service.odobriDostavnicu(data).subscribe((res) => {
          //console.log(res);
          if (res.success === true) {
            this.disabledOdobri = false;
            notify('Uspješno.', 'success', 3000);
            this.dohvatiDostavnice(this.datumOdFormatiran, this.datumDoFormatiran);

            this.pdfDostavnica(e); //dodano da se dohvaca otpremnica iz pekara tome, otkomentirati ako se nesto pokvari
            //this.pdfOtpremnicaPekarTomo(e);
          } else {
            this.disabledOdobri = false;
            notify(res.message, 'error', 3000);
          }
        });
      } else {
        this.disabledOdobri = false;
      }
    });
  }

  onValueChangedDatumOd(e) {
    this.datumOd = e.value;
    this.datumOdFormatiran = moment(e.value).format('YYYY-MM-DD');
  }
  onValueChangedDatumDo(e) {
    this.datumDo = e.value;
    this.datumDoFormatiran = moment(e.value).format('YYYY-MM-DD');
  }

  pretrazi() {
    this.dohvatiDostavnice(this.datumOdFormatiran, this.datumDoFormatiran);
  }

  onSelectionChanged(e: any): void {
    //console.log(e);
    e.component.collapseAll(-1);

    if (e.currentSelectedRowKeys[0]) {
      e.component.expandRow(e.currentSelectedRowKeys[0]);

      this.idDostavnice = e.selectedRowsData[0].pz_id;
      this.dohvatiStavke();
    }
  }

  dostavnica_detalji() {
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      pz_id: this.idDostavnice
    };
    //console.log(podaciZaSlanje);
    this.service.dostavnicaDetalji(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.sifraPoslovnice = res.data[0].po_sifra;
        this.idfirma = res.data[0].firma_fi_id;
        this.fazaId = '2';
        this.datumDokumenta = res.data[0].pz_datum;
        this.godinaDokumenta = res.data[0].pg_godina;
        this.registracijaVozila = res.data[0].pz_registracijavozila;
        this.brojKamiona = res.data[0].pz_rednibrojslepera;
        this.sifraPartnera = res.data[0].pa_sifra;
      }
    });
  }

  dohvatiStavke() {
    this.stavke = [];
    this.service.dohvatiJednuDostavnicu({ pz_id: this.idDostavnice }).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.stavke = res.data;
        //dodano na ovaj nacin zato ako ima stavki da podatke vuce iz njih (prometzag) ako nema onda je zaglavlje tek kreirano pa ce dodavati stavke zato podatke vuce iz zaglavlja (dostavnica_detalji)
        if (res.data.length > 0) {
          this.sifraPoslovnice = res.data[0].po_sifra;
          this.idfirma = res.data[0].firma_idfirma;
          this.fazaId = res.data[0].faza_idfaza;
          this.datumDokumenta = res.data[0].do_datum;
          this.godinaDokumenta = res.data[0].pg_godina;
          this.registracijaVozila = res.data[0].reg_oznaka;
          this.brojKamiona = res.data[0].rb_kamiona;
          this.sifraPartnera = res.data[0].pp_sifra;
        } else {
          this.dostavnica_detalji();
        }
      }
      //console.log('STAVKE: ', this.stavke);
    });
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }

  onRowClick(e) {
    if (
      e.rowType === 'data' &&
      e.handled !== true &&
      e.event.target.className !== 'dx-button-text'
    ) {
      var key = e.component.getKeyByRowIndex(e.rowIndex);
      var expanded = e.component.isRowExpanded(key);
      if (expanded) {
        e.component.collapseRow(key);
      } else {
        e.component.expandRow(key);
      }
    }
  }

  //nisam siguran zasto je ovo ovako bilo, 30.01.2024. zatrazeno da se makne tj. da se prikaze status
  /*
  onCellPrepared(options) {
    if (options.rowType === 'data' && options.data.pz_status === 'Z') {
      //console.log(options);
      if (options.columnIndex === 12) {
        options.cellElement.classList.add('not-visible');
      }
    }
  }
  */
  onCellPrepared(options) {
    //console.log(options);
    if (options.rowType == "data") {
      if (options.column.dataField === "pz_status") {
        if (options.value == 'I') {
          options.cellElement.classList.add('circleYellow');
        }
        if (options.value == 'U') {
          options.cellElement.classList.add('circleBlue');
        }
        if (options.value == 'S') {
          options.cellElement.classList.add('circleRed');
        }
        if (options.value == 'Z') {
          options.cellElement.classList.add('circleGreen');
        }
      }
    }

    if (options.rowType === 'data' && (options.data?.pz_status === 'Z' || options.data?.pz_status === 'S')) {
      if (options.cellElement.querySelector('.dx-link-edit')) {
        const editLink = options.cellElement.querySelector('.dx-link-edit');
        (editLink as HTMLElement).style.display = 'none';
      }

      if (options.cellElement.querySelector('.dx-link-delete')) {
        const editLink = options.cellElement.querySelector('.dx-link-delete');
        (editLink as HTMLElement).style.display = 'none';
      }
    }
  }

  pdfDostavnica(data) {
    this.dostavniceService.pdfDostavnica(data);
  }

  pdfOtpremnicaPekarTomo(data) {
    this.otpremnicePekarTomoService.pdfOtpremnicaHR(data);
  }

  odabirIspisa(data) {
    let myDialog = custom({
      title: "Ispis",
      messageHtml: "Odaberite jezik na kojem želite dokument:",
      buttons: [{
        text: "HR",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      }, {
        text: "ENG",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      }]
    });
    myDialog.show().then((dialogResult: any) => {
      if (dialogResult.buttonText === 'HR') {
        this.dostavniceService.pdfDostavnica(data);
      } else {
        this.dostavniceService.pdfDostavnica_ENG(data);
      }
    });
  }

  odabirIspisa_PekarTomo(data) {
    let myDialog = custom({
      title: "Ispis",
      messageHtml: "Odaberite jezik na kojem želite dokument:",
      buttons: [{
        text: "HR",
        onClick: (e) => {
          //console.log(e);
          this.loadingVisible = true;
          return { buttonText: e.component.option("text") }
        }
      }, {
        text: "ENG",
        onClick: (e) => {
          //console.log(e);
          this.loadingVisible = true;
          return { buttonText: e.component.option("text") }
        }
      }]
    });
    myDialog.show().then((dialogResult: any) => {
      if (dialogResult.buttonText === 'HR') {
        this.otpremnicePekarTomoService.pdfOtpremnicaHR(data).then((resKreiranHR: any) => {
          //console.log('resKreiranHR: ', resKreiranHR);
          if (resKreiranHR) {
            this.loadingVisible = false;
          }
        });
      } else {
        this.otpremnicePekarTomoService.pdfOtpremnicaENG(data).then((resKreiranENG: any) => {
          //console.log('resKreiranENG: ', resKreiranENG);
          if (resKreiranENG) {
            this.loadingVisible = false;
          }
        });
      }
    });
  }

  povezaniDokumenti(data) {
    //console.log(data);
    this.naslov = 'Popis povezanih dokumenata';
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      pz_id: data.data.pz_id,
      dv_id: data.data.dokumentvrsta_dv_id
    }
    //console.log(podaciZaSlanje);
    this.povezani_dokumenti = [];
    this.service.povezani_dokumenti_popis(podaciZaSlanje).subscribe(res => {
      //console.log(res);
      this.povezaniDokumentiPopup = true;
      if (res.success == true) {
        this.povezani_dokumenti = res.data;
      } else {

      }
    });
  }

  uredu() {
    this.povezaniDokumentiPopup = false;
  }

  addPalletePopup(e) {
    //console.log(e);
    //console.log(e.data);
    if (e.data.obavezan_sscc == 1) {
      this.obavezan_sscc_pocetno = true;
      this.obavezan_sscc = true;
    } else {
      this.obavezan_sscc_pocetno = false;
      this.obavezan_sscc = false;
    }
    this.popupAddPalleteVisible = true;

    this.dohvatiSveProizvode();

    this.odabraniProizvod = '';
    this.radniNalog_id = null;
    this.lotBroj = '';
    this.brojKutija = null;
    this.sscc = '';
    this.brojIstihPaleta = null;
  }

  dohvatiSveProizvode() {
    this.service.dohvatiSveProizvode({}).subscribe((res) => {
      this.sviProizvodi = [];

      if (res.success === true) {
        for (let data of res.data) {
          this.sviProizvodi.push({
            id: data.ar_id,
            sifra: data.ar_sifra,
            naziv: data.ar_naziv,
            sifraNaziv: data.sifrainaziv,
          });
        }
        this.sviProizvodi = new DataSource({
          store: this.sviProizvodi
        });
        //console.log(this.sviProizvodi);
      }
    });
  }

  dohvatiSveLotove(id: number) {
    let podaciZaSlanje = {
      arid: id,
    };

    this.sviLotovi = [];
    this.service.dohvatiSveLotove(podaciZaSlanje).subscribe((res) => {
      if (this.idProizvoda) {
        for (let data of res.podaci.data) {
          let vazido = '';
          let istekao = false;

          if (data.rns_vazido != null) {
            vazido = moment(data.rns_vazido).format('DD.MM.YYYY');
            // provjera je li rok istekao
            istekao = moment(data.rns_vazido).isBefore(moment(), 'day');
          } else {
            vazido = 'Nema roka trajanja';
          }

          this.sviLotovi.push({
            lotBroj: data.ar_lot + ' - Rok: ' + vazido,
            rnalozi_nl_id: data.rnalozi_nl_id,
            rokIstekao: istekao,
            originalniLot: data.ar_lot,
            rns_vazido: vazido
          });
        }
        this.sviLotoviDataSource = new DataSource({
          store: this.sviLotovi
        });
        //console.log(this.sviLotovi);
      }
    });
  }

  onChangeProizvodId(e) {
    //console.log(e);

    // resetiraj LOT kada se promijeni proizvod
    this.radniNalog_id = null;
    this.lotBroj = '';
    this.sviLotovi = [];
    this.sviLotoviDataSource = null;

    if (e.value) {
      this.idProizvoda = e.value.id;
      this.sifraArtikla = e.value.sifra;

      // dohvati lotove za novo odabrani proizvod
      this.dohvatiSveLotove(this.idProizvoda);
    } else {
      this.idProizvoda = null;
      this.sifraArtikla = '';
    }
  }

  onChangeLot(e) {
    //console.log(e);
    if (e.value) {
      this.radniNalog_id = e.value;

      // Pronađi cijeli objekt pomoću jedinstvenog ID-a
      const odabraniObjekt = this.sviLotovi.find(
        lot => lot.rnalozi_nl_id === e.value
      );

      if (odabraniObjekt) {
        this.lotBroj = odabraniObjekt.originalniLot;
        //console.log('lotBroj: ', this.lotBroj);
        //console.log('radniNalog_id: ', this.radniNalog_id);
      }
    } else {
      this.radniNalog_id = null;
      this.lotBroj = '';
    }
  }

  onChangeSscc(e) {
    //console.log(e);
    if (e.value) {
      this.sscc = e.value;
      // Obriši broj istih paleta kada se unosi SSCC kod
      this.brojIstihPaleta = null;

      if (e.value.length == 20) {
        // Blokiraj odmah dok čekamo odgovor
        this.disable_ssccBroj = true;

        let podaciZaSlanje = {
          sscc: e.value
        }
        this.service.provjeri_sscc(podaciZaSlanje).subscribe({
          next: (res) => {
            //console.log(res);
            if (res.success == true) {
              //console.log('____dobar_sscc_____');
              this.disable_ssccBroj = false;  // Odblokiraj samo ako je validan
              this.obavezan_sscc = false;
            } else {
              notify('Uneseni SSCC kod je već upisan!!!', 'error', 3000);
              this.disable_ssccBroj = true;   // Ostaje blokiran
              this.obavezan_sscc = true;
            }
          },
          error: (err) => {
            //console.error('Greška pri provjeri SSCC:', err);
            notify('Greška pri provjeri SSCC koda!', 'error', 3000);
            this.disable_ssccBroj = true;     // Ostaje blokiran
            this.obavezan_sscc = true;
          }
        });

      } else {
        notify('Neodgovarajuća dužina SSCC koda!', 'error', 3000);
        this.disable_ssccBroj = true;
      }
    } else {
      this.sscc = '';
      this.disable_ssccBroj = false;

      if (!this.brojIstihPaleta) {
        this.obavezan_sscc = this.obavezan_sscc_pocetno;
      } else {
        this.obavezan_sscc = false;
      }
    }
  }

  onKeyPressSscc(e) {
    const charCode = e.event.which ? e.event.which : e.event.keyCode;
    if (charCode < 48 || charCode > 57) {
      e.event.preventDefault();
    }
  }

  onChangeKutije(e) {
    //console.log(e);
    this.brojKutija = e.value;
  }

  onChangeBrojIstih(e) {
    if (e.value) {
      this.brojIstihPaleta = e.value;

      // Direktno postavi sve varijable bez okidanja onChangeSscc
      this.sscc = '';
      this.disable_ssccBroj = false;
      this.obavezan_sscc = false;

    } else {
      this.brojIstihPaleta = null;
      // Samo ako se stvarno briše (korisnik obrisao), a ne programski
      if (e.event) {
        this.obavezan_sscc = this.obavezan_sscc_pocetno;
      } else {

      }
    }
  }

  dodajPaletu() {

    let brIstihPaleta = 1;
    if (this.brojIstihPaleta != null && this.brojIstihPaleta != 0) {
      brIstihPaleta = Number(this.brojIstihPaleta);
    }

    let podaciZaSlanje = {
      pzid: this.idDostavnice,
      arid: this.idProizvoda,
      arsifra: this.sifraArtikla,
      rnalozi_nl_id: this.radniNalog_id,
      lot: this.lotBroj,
      ssccbroj: this.sscc,
      brojkutija: this.brojKutija,
      br_istih_paleta: this.brojIstihPaleta,
      prizlaz: null,
      user: localStorage.getItem('iduser'),
      idUser: localStorage.getItem('idsecuser'),
      posifra: this.sifraPoslovnice,
      posifra_qr: this.sifraPoslovnice,
      idfirma: this.idfirma,
      idpaleta: null,
      idfaza: this.fazaId,
      dodatum: moment(this.datumDokumenta).format('YYYY-MM-DD hh:mm:ss'),
      godina: this.godinaDokumenta,
      registracija: this.registracijaVozila,
      rbkamiona: this.brojKamiona,
      ppsifra: this.sifraPartnera,
    };
    //console.log('PODACI ZA SLANJE:  ', podaciZaSlanje);
    this.service.dodajNoveStavkePalete(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.dohvatiStavke();
        let dostavnicaKojojSePovecavaBrojPaleta = this.dostavnice.find(d => d.pz_id === this.idDostavnice);
        //console.log(dostavnicaKojojSePovecavaBrojPaleta.brojpaleta);
        dostavnicaKojojSePovecavaBrojPaleta.brojpaleta = dostavnicaKojojSePovecavaBrojPaleta.brojpaleta + brIstihPaleta;
        //console.log(dostavnicaKojojSePovecavaBrojPaleta.brojpaleta);
        notify('Uspješno dodavanje palete.', 'success', 3000);
      } else {
        notify('Došlo je do pogreške! Paleta nije dodana!', 'error', 3000);
      }
    });

    this.odabraniProizvod = '';
    this.radniNalog_id = null;
    this.lotBroj = '';
    this.brojKutija = null;
    this.sscc = '';
    this.brojIstihPaleta = null;

    this.popupAddPalleteVisible = false;
  }
}
